const { ASSET_ENV } = process.env;

const isProduction = ASSET_ENV === "prod";

exports.CAT_LOGGER_API = "/api/cat_logger";

exports.MMS_URL = isProduction ? "//mms.pinduoduo.com" : "//mms.htj.pdd.net";
exports.DMP_URL = isProduction ? "//dmp.pinduoduo.com" : "//dmp.htj.pdd.net";
